var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNestlogoLightv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6b6e71;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #daebf9;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #aeb1b3;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.53,25.42c-5.74,7.12-15.74,9.61-16.65,20.08-.22,2.55,1.09,3.4-2.12,1.86-9.37-4.48-2.33-17.57,5-21.21s10.95-4.22,16.96-10.42c.53-.55,1.2-2.42,1.07-.06-.18,3.3-2.22,7.21-4.26,9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.87,25.34c.17.07,1.76,2.72,1.92,3.05,6.03,12.28-4.73,21.24-15.29,24.96-6.94,2.44-15.05,2.35-21.79-.7l4.84.06c11.97.66,30.51-8.98,30.57-22.79,0-1.04-.66-3.9-.62-4.28.02-.19.17-.39.37-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.05,25.22c.16.19-.72,4.17-.75,4.96-.37,9.87,8.22,16.83,16.6,19.98.41.15,2.8.31,1.29.94-.63.27-4.27.18-5.15.11-11.78-.94-20.26-9.95-14.99-21.9.16-.35,2.55-4.62,3-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.46,46.82c-3.13,14.67-18.12,23.9-32.59,20.53-5.42-1.26-11.11-4.46-14.31-8.98,7.09,4.28,16.34,5.72,23.73,1.32-.24-.08-.61.03-.88.06-4.34.58-6.65,1.31-11.22.73-6.22-.78-13.37-3.56-16.12-9.62-.56-1.23-2.34-7.7-1.67-8.57.15-.19,2.01,3.41,2.28,3.81,5.38,7.77,19.45,12.67,28.61,11.26,9.26-1.43,18.05-7.36,21.6-16.14.13-.33.74-3.37,1.13-2.24.4,1.18-.26,6.37-.57,7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.35,12.83c6.51,3.67.47,14.71-6.37,9.95-5.77-4.01-.44-13.8,6.37-9.95Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.44,64.37V19.72h26.79c2.46,0,4.56.88,6.28,2.65,1.77,1.77,2.65,3.86,2.65,6.28v35.72h-8.93V28.65h-17.86v35.72h-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.88,64.37c-2.51,0-4.63-.86-6.35-2.58-1.72-1.77-2.58-3.88-2.58-6.35v-26.79c0-2.46.86-4.56,2.58-6.28,1.77-1.77,3.88-2.65,6.35-2.65h26.79v8.93h-26.79v8.93h26.79v8.93h-26.79v8.93h26.79v8.93h-26.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.45,64.37v-8.93h26.79v-8.93h-17.86c-2.51,0-4.63-.86-6.35-2.58-1.72-1.77-2.58-3.88-2.58-6.35v-8.93c0-2.46.86-4.56,2.58-6.28,1.77-1.77,3.88-2.65,6.35-2.65h26.79v8.93h-26.79v8.93h17.86c2.46,0,4.56.88,6.28,2.65,1.77,1.77,2.65,3.86,2.65,6.28v8.93c0,2.51-.88,4.63-2.65,6.35-1.77,1.72-3.86,2.58-6.28,2.58h-26.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.89,64.37V28.65h-8.93v-8.93h26.79v8.93h-8.93v35.72h-8.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestlogoLightv);
export default __webpack_public_path__ + "static/media/NEST LOGO_Lightv.bfa8c4edb859481fd9165c7395eba04e.svg";
export { ForwardRef as ReactComponent };